export default "__VITE_ASSET__BFBNKxLp__"